// extracted by mini-css-extract-plugin
module.exports = {"buttons":"BrowseSkeleton_buttons__MJ9Vy"};